import { checkAndExecute } from 'root/api/helpers';

export default function ManageCompaniesApi(api) {

  Object.assign(api, {
    setAccountManagers: (agencyId, companyId, managers, notify) => checkAndExecute(
      () => agencyId && companyId,
      () => api.server.post(`manage-accounts/${agencyId}/set-managers/${companyId}`, {managers, notify})),

    deleteCompany: (accountId, targetId) => checkAndExecute(
      () => accountId && targetId,
      () => api.server.delete(`manage-accounts/delete/${accountId}/${targetId}`)),

    updatePrimaryContact: (accountId, contact) => checkAndExecute(
      () => accountId && contact,
      () => api.server.put(`manage-accounts/${accountId}/update-primary-contact`, contact)),

    findAccountManagedByAgency: (agencyId, accountId) => checkAndExecute(
      () => accountId && agencyId,
      () => api.server.get(`manage-accounts/${agencyId}/get/${accountId}`)
    )
  });
}
